export default __webpack_public_path__ + "static/media/cash 1.014662a2.svg";